import { useEffect } from "react";
import { CTAButton } from "../components/ui-regera/CTAButton";
import { Frame, Head } from "../components/spec/Frame";
import { INNOVATION_PAGE } from "../data/content";

export default function Innovation() {
  useEffect(() => {
    document.title = "Innovation — REGERA";
  }, []);
  const { pov, areas, apply } = INNOVATION_PAGE;
  return (
    <div data-testid="innovation-page">
      <Frame id="innov-pov" first>
        <Head as="h1" size="lg" {...pov} />
      </Frame>
      <Frame id="innov-areas">
        <Head overline={areas.overline} title={areas.title} />
        <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {areas.items.map((a, i) => (
            <div key={a.title} data-pg-item className="bg-[#0a0a0a] p-6">
              <span className="font-display text-sm font-bold text-[#e60000]">{String(i + 1).padStart(2, "0")}</span>
              <h3 className="mt-3 font-display text-lg lg:text-xl font-bold text-white">{a.title}</h3>
              <p className="mt-2 text-white/75 leading-relaxed">{a.text}</p>
            </div>
          ))}
        </div>
      </Frame>
      <Frame id="innov-apply">
        <Head {...apply} />
        <CTAButton to={`/contact?area=${encodeURIComponent("Technology Advisory")}#enquiry`} testId="innovation-engage-cta" className="mt-10">Discuss an Innovation Opportunity</CTAButton>
      </Frame>
    </div>
  );
}
